import api from "../../../services/api";
import gridClientBase from "../../../components/gridClientComponentBase";
import cellDeleteCommand from "../../../components/grid/cellDeleteCommand/cellDeleteCommand.vue";
import cellTemplate from "../../../components/grid/cellTemplate/cellTemplate.vue";
import headerTemplate from "../../../components/grid/headerTemplate/headerTemplate.vue";

export default {
	extends: gridClientBase,
	components: {},

	data: function() {
		return {
			loading: false,
			savePendingRequest: null

			// items: []
		};
	},

	created() {
		this.getData();
		var newItem = {
			id: this.indexNewItem,
			name: "",
			description: ""
		};
		this.defaultAddRow = newItem;
		this.sort = [{field: "name", dir: "asc"}];
	},

	/* metodi */
	methods: {
		saveData: function() {
			var self = this;
			if (this.savePendingRequest == null) {
				this.savePendingRequest = api.postPoiCategoriesData(this.createdItems, this.updatedItems, this.deletedItems)
				.then(res => {
					self.createdItems = [];
					self.updatedItems = [];
					self.deletedItems = [];

					self.isInEditMode = false;
					self.getData();
				})
				.catch(err => {
					console.log("KO" + err);
				}).finally(_ => {
					self.savePendingRequest = null;
				});
			}
		},

		getData: function() {
			var self = this;
			this.loading = true;

			this.getPoiCategories(self);
		},

		getPoiCategories: function(self) {
			api.getPoiCategoriesData().then(res => {
				self.loading = false;
				self.items = res.map(function(item) {
					return {
						id: item.id,
						name: item.name,
						description: item.description,
						background_color: item.background_color || null,
						icon_image: item.icon_image
					};
				});
			});
		},

		switchEditMode: function() {
			this.isInEditMode = !this.isInEditMode;

			if (!this.isInEditMode) {
				this.clearWorkingData();
				this.getData();
			}

			this.savePendingRequest = null;
		},

		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		}
	},

	/* visualizzazione risultati */
	computed: {
		columns: function() {
			return [
				{
					field: "name",
					title: "nome",
					width: "210",
					cell: "myCellTemplate",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "description",
					title: "descrizione",
					width: "300",
					cell: "myCellTemplateNotRequired",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "background_color",
					title: "colore sfondo",
					cell: "myCellTemplate",
					format: "color",
					width: "130",
					minResizableWidth: '100',
					headerCell: "myHeaderTemplate",
					sortable: false
				},
				{
					field: "icon_image",
					title: "immagine",
					cell: "myCellTemplate",
					format: "image",
					width: "90",
					headerCell: "myHeaderTemplate",
					sortable: false
				},
				{
					field: "",
					title: "",
					cell: "",
					format: "",
					width: "",
					headerCell: "",
					sortable: false,
					filterable: false
				},
				{
					cell: cellDeleteCommand,
					width: "45",
					minResizableWidth: '45',
					sortable: false,
					headerCell: "myHeaderTemplate"
				}
			];
		}
	}
};
